import { css } from 'emotion';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { inject } from 'dependable-react';

import { I18N_TOKEN } from '../services/InjectTokens';

const backdrop = css`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: 100%;
  background-color: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow-y: auto;
`;

const wrapper = css`
  position: relative;
  cursor: pointer;
  text-align: center;
  max-width: 500px;
  width: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: 0px 0px 21px 0 rgba(0, 0, 0, 0.21);
  padding: 50px 30px;

  h3 {
    font-family: Nunito, Arial, Helvetica, sans-serif;
    color: #12293e;
    margin-bottom: 12px;
  }

  p {
    margin-bottom: 12px;
    font-family: Nunito, Arial, Helvetica, sans-serif;
    font-size: 16px;
    color: #707070;
  }
`;

const buttonWrapper = css`
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const buttonOk = css`
  font-size: 16px;
  font-weight: bold;
  background-color: #71659f;
  border-radius: 3px;
  color: #ffffff;
  text-transform: uppercase;
  padding: 10px 15px;
  transition: all 0.4s ease;
  transform: scale(1);
  cursor: pointer;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  line-height: 16px;
  margin-bottom: 12px;
  min-width: 200px;

  &:hover {
    transform: scale(1.05);
  }
`;

const buttonCancel = css`
  font-size: 16px;
  font-weight: bold;
  background-color: transparent;
  border-radius: 3px;
  border: 1px solid #71659f;
  color: #71659f;
  text-transform: uppercase;
  padding: 10px 15px;
  transition: all 0.4s ease;
  transform: scale(1);
  cursor: pointer;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  line-height: 16px;
  min-width: 200px;

  &:hover {
    transform: scale(1.05);
  }
`;

interface IProps {
  isOpen: boolean;
  contentTranslationKey: string;
  titleTranslationKey: string;
  callbackAccept?: (e?: any) => void;
  callbackDecline?: (e?: any) => void;
}

export const DedicationPopup = observer(
  ({ isOpen, contentTranslationKey, titleTranslationKey, callbackAccept, callbackDecline }: IProps) => {
    const i18n = inject(I18N_TOKEN);
    return isOpen ? (
      <div className={backdrop}>
        <div className={wrapper}>
          <h3>{i18n.t(titleTranslationKey)}</h3>
          <p dangerouslySetInnerHTML={{ __html: i18n.t(contentTranslationKey) }} />
          {(callbackAccept || callbackDecline) && (
            <div className={buttonWrapper}>
              {callbackAccept && (
                <button onClick={(e) => callbackAccept(e)} className={buttonOk}>
                  {i18n.t('dedication_add_new')}
                </button>
              )}

              {callbackDecline && (
                <button onClick={(e) => callbackDecline(e)} className={buttonCancel}>
                  {i18n.t('dedication_keep_old')}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    ) : (
      <></>
    );
  },
);
